<!-- SiteFooter.vue -->
<template>
  <footer class="nebula-site-footer">
    <div v-if="isLoading" class="nebula-footer-skeleton">
      <!-- 스켈레톤 UI -->
      <div class="skeleton skeleton-banner"></div>
      <div class="skeleton skeleton-menu"></div>
      <div class="skeleton skeleton-company"></div>
<!--      <div class="skeleton skeleton-customer"></div>-->
<!--      <div class="skeleton skeleton-badges"></div>-->
      <div class="skeleton skeleton-copyright"></div>
    </div>

    <div v-else>
      <!-- 상단 배너 (보톡스 광고) -->
<!--      <div class="nebula-footer-banner">-->
<!--        <div class="nebula-container">-->
<!--          <img :src="require('@/assets/user/footer/하단_띠배너.png')" alt="하단 띠배너" />-->
<!--        </div>-->
<!--      </div>-->

      <!-- 회사 메뉴 -->
      <div class="nebula-company-menu">
        <div class="nebula-container">
          <ul class="nebula-menu-list">
            <li class="nebula-menu-item"><a href="#" @click.prevent="openPopup('company')">회사소개</a></li>
            <li class="nebula-menu-item"><a href="#" @click.prevent="openPopup('terms')">이용약관</a></li>
            <li class="nebula-menu-item"><a href="#" @click.prevent="openPopup('privacy')">개인정보처리방침</a></li>
            <li class="nebula-menu-item"><a href="#" @click.prevent="openPopup('guide')">이용안내</a></li>
          </ul>
        </div>
      </div>

      <!-- 회사 정보 -->
      <div class="nebula-company-info">
        <div class="nebula-container">
          <div class="nebula-info-grid">
            <!-- 회사 로고 및 정보 -->
            <div class="nebula-company-details">
              <div class="nebula-company-logo">
                <img v-if="storeConfig.logoUrl" :src="getImageUrl(storeConfig.logoUrl)" alt="회사 로고">
                <img v-else src="@/assets/images/toolstar_logo.png" alt="기본 로고">
              </div>
              <div><a href="#" class="nebula-company-intro-btn">회사소개서</a></div>
            </div>
            <div class="nebula-company-text">
              <p>상호 : {{ storeConfig.name || '(주)태경공구' }} | 대표 : {{ storeConfig.ceoName || '김 형 래' }}</p>
              <p>물류센터 본사 : {{ getFullAddress() }}</p>
              <p>사업자등록번호 : {{ storeConfig.businessNumber || '424-86-01868' }}</p>
              <p>통신판매업신고 : 제 2020-진접오남-0339 호</p>
              <p>이메일 : {{ storeConfig.email || 'cs@toolstar.kr' }}</p>
              <p>개인정보책임관리자 : {{ storeConfig.ceoName || '김형래' }}</p>
            </div>
            <!-- 고객센터 정보 -->
            <div class="nebula-customer-center">
              <div class="nebula-center-header">
                <div class="nebula-center-icon">
                  <img src="@/assets/user/footer/free-icon-apple-831309.png" alt="임시 이미지">
                </div>
                <h3 class="nebula-center-title">고객센터</h3>
              </div>
              <div class="nebula-center-info">
                <p>운영시간 : 월요일 - 금요일 09:00 ~ 18:00 (점심시간 12:00 ~ 13:00)</p>
                <p>TEL. {{ storeConfig.phone || '070-8858-0954' }} | FAX. 준비중</p>
              </div>

              <!-- 문의 버튼 -->
              <div class="nebula-contact-buttons">
                <a href="#" class="nebula-contact-btn">
                  <div class="nebula-contact-icon">
                    <img src="@/assets/user/footer/free-icon-chat-bot-8649607.png" alt="임시 이미지">
                  </div>
                  <span>채팅문의</span>
                </a>
                <a href="#" class="nebula-contact-btn">
                  <div class="nebula-contact-icon">
                    <img src="@/assets/user/footer/free-icon-chat-bot-8794620.png" alt="임시 이미지">
                  </div>
                  <span>전화문의</span>
                </a>
                <a href="#" class="nebula-contact-btn">
                  <div class="nebula-contact-icon">
                    <img src="@/assets/user/footer/free-icon-fax-machine-5075753.png" alt="임시 이미지">
                  </div>
                  <span>FAX문의</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 인증 배지 -->
<!--      <div class="nebula-certifications">-->
<!--        <div class="nebula-container">-->
<!--          <div class="nebula-badges">-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo1.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo2.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo3.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo4.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <!-- 저작권 정보 -->
      <div class="nebula-copyright">
        <div class="nebula-container">
          <p>© 2025 {{ storeConfig.name || 'Toolstart' }}. All Rights Reserved.</p>
        </div>
      </div>
    </div>

    <!-- 팝업 모달 -->
    <div v-if="showPopup" class="footer-popup-overlay" @click.self="closePopup">
      <div class="footer-popup">
        <div class="footer-popup-header">
          <h3>{{ popupTitle }}</h3>
          <button class="popup-close-btn" @click="closePopup">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>
        <div class="footer-popup-content">
          <!-- 회사소개 -->
          <div v-if="popupType === 'company'" class="popup-section">
            <h4>{{ storeConfig.name || '(주)태경공구' }}</h4>
            <div class="company-intro">
              <p><strong>대표이사:</strong> {{ storeConfig.ceoName || '김형래' }}</p>
              <p><strong>설립일:</strong> 2020년</p>
              <p><strong>주소:</strong> {{ getFullAddress() }}</p>
              <p><strong>사업분야:</strong> 산업용 공구 및 장비 도소매</p>
            </div>
            <div class="company-description">
              <h5>회사 소개</h5>
              <p>{{ storeConfig.name || '(주)태경공구' }}는 고품질의 산업용 공구와 장비를 합리적인 가격에 제공하는 B2B 전문 유통업체입니다.</p>
              <p>전동공구, 측정공구, 절단공구, 안전장비 등 다양한 제품군을 보유하고 있으며, 신속한 배송과 전문적인 기술 지원 서비스를 제공합니다.</p>
            </div>
          </div>

          <!-- 이용약관 -->
          <div v-if="popupType === 'terms'" class="popup-section">
            <h4>이용약관</h4>
            <div class="terms-content">
              <h5>제1조 (목적)</h5>
              <p>이 약관은 {{ storeConfig.name || '(주)태경공구' }}(이하 "회사")이 운영하는 온라인 쇼핑몰에서 제공하는 서비스의 이용조건 및 절차, 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>

              <h5>제2조 (용어의 정의)</h5>
              <p>1. "쇼핑몰"이란 회사가 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장을 말합니다.</p>
              <p>2. "이용자"란 쇼핑몰에 접속하여 이 약관에 따라 쇼핑몰이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</p>

              <h5>제3조 (약관의 효력과 변경)</h5>
              <p>1. 이 약관은 쇼핑몰 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.</p>
              <p>2. 회사는 합리적인 사유가 발생할 경우 약관을 변경할 수 있으며, 변경된 약관은 공지 후 효력이 발생합니다.</p>

              <h5>제4조 (서비스의 제공 및 변경)</h5>
              <p>1. 회사는 다음과 같은 업무를 수행합니다.</p>
              <p>- 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결</p>
              <p>- 구매계약이 체결된 재화 또는 용역의 배송</p>
              <p>- 기타 회사가 정하는 업무</p>
            </div>
          </div>

          <!-- 개인정보처리방침 -->
          <div v-if="popupType === 'privacy'" class="popup-section">
            <h4>개인정보처리방침</h4>
            <div class="privacy-content">
              <h5>1. 개인정보의 수집 및 이용 목적</h5>
              <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다.</p>
              <p>- 회원 가입 및 관리: 회원제 서비스 이용에 따른 본인확인, 회원자격 유지·관리</p>
              <p>- 재화 또는 서비스 제공: 물품배송, 서비스 제공, 청구서 발송, 콘텐츠 제공</p>
              <p>- 마케팅 및 광고 활용: 이벤트 및 광고성 정보 제공 및 참여기회 제공</p>

              <h5>2. 수집하는 개인정보 항목</h5>
              <p>- 필수항목: 성명, 아이디, 비밀번호, 이메일, 연락처, 주소</p>
              <p>- 선택항목: 사업자등록번호, 회사명, 직책</p>

              <h5>3. 개인정보의 보유 및 이용기간</h5>
              <p>회원 탈퇴 시까지 또는 법령에 따른 보존기간까지 보유합니다.</p>

              <h5>4. 개인정보의 파기</h5>
              <p>개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p>

              <h5>5. 개인정보 보호책임자</h5>
              <p>성명: {{ storeConfig.ceoName || '김형래' }}</p>
              <p>연락처: {{ storeConfig.phone || '070-8858-0954' }}</p>
              <p>이메일: {{ storeConfig.email || 'cs@toolstar.kr' }}</p>
            </div>
          </div>

          <!-- 이용안내 -->
          <div v-if="popupType === 'guide'" class="popup-section">
            <h4>이용안내</h4>
            <div class="guide-content">
              <h5>1. 회원가입</h5>
              <p>- 회원가입은 무료이며, 사업자 및 개인 모두 가입 가능합니다.</p>
              <p>- 사업자 회원은 사업자등록증 제출 후 승인 절차가 필요합니다.</p>

              <h5>2. 주문방법</h5>
              <p>- 상품 선택 → 장바구니 담기 → 주문서 작성 → 결제 → 주문완료</p>
              <p>- 견적서가 필요한 경우 고객센터로 문의해 주세요.</p>

              <h5>3. 결제방법</h5>
              <p>- 신용카드, 계좌이체, 무통장입금, 가상계좌, 여신결제</p>
              <p>- 사업자 회원: 세금계산서 발행 후 익월 결제 가능 (신용도 심사 후)</p>

              <h5>4. 배송안내</h5>
              <p>- 기본배송비: 3,500원 (300,000원 이상 무료배송)</p>
              <p>- 평일 오후 4시 이전 주문 시 당일 발송</p>
              <p>- 도서산간 지역은 추가 배송비가 발생할 수 있습니다.</p>

              <h5>5. 반품/교환</h5>
              <p>- 상품 수령 후 7일 이내 신청 가능</p>
              <p>- 제품 하자 시 무료 교환/반품</p>
              <p>- 단순 변심 시 왕복 배송비 고객 부담</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SiteFooter',
  data() {
    return {
      isLoading: true,
      showPopup: false,
      popupType: '',
      storeConfig: {
        name: '',
        ceoName: '',
        businessNumber: '',
        phone: '',
        email: '',
        address1: '',
        address2: '',
        zipCode: '',
        logoUrl: ''
      },
      baseURL: process.env.NODE_ENV === 'production'
          ? 'https://toolstar.kr'
          : 'http://localhost:8080'
    };
  },
  computed: {
    popupTitle() {
      const titles = {
        company: '회사소개',
        terms: '이용약관',
        privacy: '개인정보처리방침',
        guide: '이용안내'
      };
      return titles[this.popupType] || '';
    }
  },
  async mounted() {
    await this.loadStoreConfig();
  },
  methods: {
    async loadStoreConfig() {
      try {
        this.isLoading = true;

        const response = await axios.get(`${this.baseURL}/api/config/store`);

        if (response.data) {
          this.storeConfig = {
            ...this.storeConfig,
            ...response.data
          };
          console.log('회사 정보 로드 완료:', this.storeConfig);
        }
      } catch (error) {
        console.error('회사 정보 로드 실패:', error);
        // 에러 발생 시 기본값 유지
      } finally {
        this.isLoading = false;
      }
    },

    getFullAddress() {
      const parts = [];
      if (this.storeConfig.address1) parts.push(this.storeConfig.address1);
      if (this.storeConfig.address2) parts.push(this.storeConfig.address2);

      return parts.length > 0
          ? parts.join(' ')
          : '경기도 남양주시 진접읍 금강로 1133';
    },

    getImageUrl(imageUrl) {
      if (!imageUrl) return '';

      if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
        return imageUrl;
      }

      return `${this.baseURL}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
    },

    openPopup(type) {
      this.popupType = type;
      this.showPopup = true;
      document.body.style.overflow = 'hidden';
    },

    closePopup() {
      this.showPopup = false;
      this.popupType = '';
      document.body.style.overflow = '';
    }
  }
};
</script>

<style scoped>
.nebula-site-footer {
  font-family: 'Noto Sans KR', sans-serif;
  color: #333;
}

.nebula-container {
  max-width: 1370px;
  margin: 0 auto;
  padding: 0 15px;
}
.nebula-container img {
  max-width: 100%;
  margin: 0 auto;
}
/* 상단 배너 */
.nebula-footer-banner {
  background-color: #17001C;
  padding: 0;
}

.nebula-banner-img {
  width: 100%;
  display: block;
}

/* 회사 메뉴 */
.nebula-company-menu {
  background-color: #f0f0f0;
  padding: 15px 0;
}

.nebula-menu-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

.nebula-menu-item {
  margin-right: 20px;
}

.nebula-menu-item a {
  color: #333;
  text-decoration: none;
  font-size: 14px;
}

.nebula-menu-item a:hover {
  text-decoration: underline;
}

/* 회사 정보 */
.nebula-company-info {
  background-color: #f8f8f8;
  padding: 30px 0;
}

.nebula-info-grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
}

.nebula-company-details {
  flex: 2;
  max-width: 25%;
  position: relative;
}

.nebula-company-logo {
  margin-bottom: 15px;
}

.nebula-company-logo img {
  max-width: 200px;
}

.nebula-company-text p {
  margin: 5px 0;
  font-size: 13px;
  color: #666;
}

.nebula-company-intro-btn {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  padding: 8px 15px;
  background-color: #555;
  color: #fff;
  font-size: 13px;
  text-decoration: none;
  border-radius: 3px;
}

.nebula-company-intro-btn:hover {
  background-color: #444;
}

/* 고객센터 정보 */
.nebula-customer-center {
  flex: 1;
  max-width: 30%;
  padding: 0 15px;
}

.nebula-center-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.nebula-center-icon {
  margin-right: 8px;
}

.nebula-center-icon img {
  width: 24px;
  height: 24px;
}

.nebula-center-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.nebula-center-info p {
  margin: 5px 0;
  font-size: 13px;
  color: #666;
}

/* 문의 버튼 */
.nebula-contact-buttons {
  display: flex;
  gap: 15px;
  margin-top: 15px;
}

.nebula-contact-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  flex: 1;
  padding: 15px 10px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.nebula-contact-icon {
  margin-bottom: 8px;
}

.nebula-contact-icon img {
  width: 30px;
  height: 30px;
}

.nebula-contact-btn span {
  font-size: 12px;
  color: #333;
}

/* 인증 배지 */
.nebula-certifications {
  background-color: #fff;
  padding: 20px 0;
  border-top: 1px solid #eee;
}

.nebula-badges {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0px;
}

.nebula-badge {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 265px;
  border: 0px solid #eee;
  padding: 50px 0px;
  border-radius: 5px;
}

.nebula-badge img {
  margin-right: 0px;
}

.nebula-badge-text p {
  margin: 3px 0;
  font-size: 11px;
  color: #777;
}

/* 저작권 정보 */
.nebula-copyright {
  background-color: #f0f0f0;
  padding: 15px 0;
  text-align: center;
}

.nebula-copyright p {
  margin: 0;
  font-size: 12px;
  color: #999;
}

/* 스켈레톤 공통 */
/* 기본 스타일 유지 */
.nebula-site-footer {
  font-family: 'Noto Sans KR', sans-serif;
  color: #333;
}

/* 스켈레톤용 스타일 */
.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: pulse 1.5s ease-in-out infinite;
  border-radius: 6px;
  margin-bottom: 10px;
}

.skeleton-banner {
  height: 80px;
  margin: 10px 0;
}

.skeleton-menu {
  height: 50px;
  margin: 10px 0;
}

.skeleton-company {
  height: 220px;
}

.skeleton-customer {
  height: 160px;
}

.skeleton-badges {
  height: 140px;
}

.skeleton-copyright {
  height: 40px;
  margin-top: 10px;
}

@keyframes pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* 팝업 모달 */
.footer-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.footer-popup {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 700px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.footer-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 1px solid #eee;
  background: #f8f9fa;
  border-radius: 12px 12px 0 0;
}

.footer-popup-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.popup-close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  padding: 5px;
  line-height: 1;
  transition: color 0.2s;
}

.popup-close-btn:hover {
  color: #333;
}

.footer-popup-content {
  padding: 25px;
  overflow-y: auto;
  flex: 1;
}

.popup-section h4 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
  padding-bottom: 15px;
  border-bottom: 2px solid #007bff;
}

.popup-section h5 {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 20px 0 10px 0;
}

.popup-section p {
  font-size: 14px;
  color: #555;
  line-height: 1.7;
  margin: 8px 0;
}

.company-intro {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.company-intro p {
  margin: 8px 0;
}

/* 반응형 스타일 (PC는 그대로, 모바일만 수정) */
@media (max-width: 992px) {
  .nebula-info-grid {
    flex-direction: column;
  }

  .nebula-company-details,
  .nebula-customer-center {
    max-width: 100%;
  }

  .nebula-badges {
    justify-content: center;
  }

  .nebula-badge {
    flex: 0 0 calc(50% - 15px);
  }

}

@media (max-width: 768px) {
  .nebula-company-menu {
    padding: 12px 0;
  }

  .nebula-menu-list {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px 15px;
  }

  .nebula-menu-item {
    margin-right: 0;
  }

  .nebula-menu-item a {
    font-size: 13px;
  }

  .nebula-company-info {
    padding: 20px 0;
  }

  .nebula-info-grid {
    gap: 20px;
  }

  .nebula-company-details {
    padding-bottom: 20px;
  }

  .nebula-company-intro-btn {
    position: static;
    margin-top: 15px;
    display: inline-block;
  }

  .nebula-company-logo img {
    max-width: 150px;
  }

  .nebula-company-text p {
    font-size: 12px;
    line-height: 1.6;
  }

  .nebula-customer-center {
    padding: 0;
  }

  .nebula-center-info p {
    font-size: 12px;
  }

  .nebula-contact-buttons {
    gap: 10px;
  }

  .nebula-contact-btn {
    padding: 12px 8px;
  }

  .nebula-contact-icon img {
    width: 24px;
    height: 24px;
  }

  .nebula-contact-btn span {
    font-size: 11px;
  }

  .nebula-badges {
   display: none;
  }

  /* 팝업 모바일 */
  .footer-popup-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .footer-popup {
    max-width: 100%;
    max-height: 85vh;
    border-radius: 16px 16px 0 0;
  }

  .footer-popup-header {
    padding: 16px 20px;
    border-radius: 16px 16px 0 0;
  }

  .footer-popup-header h3 {
    font-size: 16px;
  }

  .footer-popup-content {
    padding: 20px;
  }

  .popup-section h4 {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .popup-section h5 {
    font-size: 14px;
    margin: 15px 0 8px 0;
  }

  .popup-section p {
    font-size: 13px;
  }

  .company-intro {
    padding: 15px;
  }
}

@media (max-width: 576px) {
  .nebula-menu-list {
    gap: 6px 12px;
  }

  .nebula-menu-item a {
    font-size: 12px;
  }

  .nebula-company-text p {
    font-size: 11px;
  }

  .nebula-contact-buttons {
    flex-wrap: wrap;
  }

  .nebula-contact-btn {
    flex: 0 0 calc(33.33% - 10px);
  }

  .nebula-copyright p {
    font-size: 11px;
  }
}
</style>
